// extracted by css-extract-rspack-plugin
export default {"trade-count":"G05eM3","tradeCount":"G05eM3","download-icon":"G9YTk_","downloadIcon":"G9YTk_","resell-button-wrapper":"TwLgYd","resellButtonWrapper":"TwLgYd"};